<template>
  <component
    ref="dynamicComp"
    :is="componentLoader"
  ></component>
</template>

<script>
export default {
  name: "taskBox",
  props: {
    src: {
      type: String,
      default: () => null
    },
  },
  mounted() {
    if (this.$props.src) {
      this.loadComponent();
    }
  },
  computed: {
    componentLoader() {
      return () => import(`@/views/shuffle/main/${this.src}.vue`);
    }
  },
  methods: {
    loadComponent() {
      this.componentLoader().then(() => {});
    }
  }
};
</script>
